/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-sample.reducer';

export const DiaglabSampleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabSampleEntity = useAppSelector(state => state.diaglabSample.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabSampleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabSample.detail.title">DiaglabSample</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.id}</dd>
          <dt>
            <span id="accessionNumber">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.accessionNumber">Accession Number</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.accessionNumber}</dd>
          <dt>
            <span id="domain">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.domain">Domain</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.domain}</dd>
          <dt>
            <span id="clientReferenceRemarks">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.clientReferenceRemarks">Client Reference Remarks</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.clientReferenceRemarks}</dd>
          <dt>
            <span id="priority">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.priority">Priority</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.priority}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.quantity}</dd>
          <dt>
            <span id="collectionDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.collectionDate">Collection Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.collectionDate}</dd>
          <dt>
            <span id="revision">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.revision">Revision</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.revision}</dd>
          <dt>
            <span id="referredToOrFrom">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.referredToOrFrom">Referred To Or From</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.referredToOrFrom}</dd>
          <dt>
            <span id="sourceOfSample">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.sourceOfSample">Source Of Sample</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.sourceOfSample}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.timestampEntry}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.status">Status</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.status}</dd>
          <dt>
            <span id="typeOfSample">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.typeOfSample">Type Of Sample</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.typeOfSample}</dd>
          <dt>
            <span id="uom">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.uom">Uom</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.uom}</dd>
          <dt>
            <span id="rejectReason">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.rejectReason">Reject Reason</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleEntity.rejectReason}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSample.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabSampleEntity.diagLab ? diaglabSampleEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSample.labBill">Lab Bill</Translate>
          </dt>
          <dd>{diaglabSampleEntity.labBill ? diaglabSampleEntity.labBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSample.collector">Collector</Translate>
          </dt>
          <dd>{diaglabSampleEntity.collector ? diaglabSampleEntity.collector.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-sample" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-sample/${diaglabSampleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabSampleDetail;
